import { useMemo } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { IconDelete } from 'src/assets/icons/Delete';
import { IconEditPencil } from 'src/assets/icons/IconEditPencil';
import { ContextMenu } from 'src/components/ContextMenu';

import { SIDEBAR_ACTION } from '../../lib';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
  visualLanguage: PropTypes.shape({}).isRequired,
  onSidebarAction: PropTypes.func.isRequired,
};

const defaultProps = {
  className: '',
};

export const VisualLanguageContextMenu = ({
  className,
  visualLanguage,
  onSidebarAction,
  ...restProps
}) => {
  const styles = useStyles();

  const contextMenuItems = useMemo(
    () => [
      {
        id: 'edit',
        dataTestId: `editVisualLanguage${visualLanguage.id}MenuItem`,
        label: 'Edit visual language',
        onClick: () => onSidebarAction(SIDEBAR_ACTION.editVisualLanguage, visualLanguage),
        icon: <IconEditPencil />,
      },

      {
        id: 'delete',
        dataTestId: `deleteVisualLanguage${visualLanguage.id}MenuItem`,
        label: 'Delete',
        onClick: () => onSidebarAction(SIDEBAR_ACTION.deleteVisualLanguage, visualLanguage),
        icon: <IconDelete />,
      },
    ],
    [visualLanguage, onSidebarAction]
  );

  return (
    <ContextMenu
      className={cx(styles.collapseButtonActionMenu, className)}
      items={contextMenuItems}
      horizontal
      small
      {...restProps}
    />
  );
};

VisualLanguageContextMenu.displayName = 'VisualLanguageContextMenu';
VisualLanguageContextMenu.propTypes = propTypes;
VisualLanguageContextMenu.defaultProps = defaultProps;
